import React from 'react'
import { Table } from 'react-bootstrap'

import { formatMoney } from '../../../helpers/utils'
import ClientHeader from '../../../components/ClientHeader/ClientHeader'
import DetailsSummarySection from '../../../components/details/summary/DetailsSummarySection'
import PaymentAttachmentsCard from '../../../components/details/attachments/PaymentAttachmentsCard'
import TotalsSummaryCard from '../../../components/TotalsSummaryCard'

import { REFUND_HEADER_CONFIG } from '../shared/refundConstants'
import { getRefundRowSubtotal, getRefundWeight } from '../shared/refundDetailsHelpers'

export default function RefundSalesmanDetailsDesktop({
  headerData,
  summaryFields,
  fieldsToRender,
  paymentAttachments,
  processedDetails,
  extraColumns,
  totalRows
}) {
  const formattedTotalRows = totalRows.map((row) =>
    row
      ? {
          ...row,
          value:
            row.label === 'PESO TOTAL:'
              ? getRefundWeight(row.value)
              : formatMoney(Number(row.value || 0))
        }
      : row
  )

  return (
    <div className="container-fluid px-0">
      <div className="show-product-header">
        <h3 className="margin-text-subtitle">Detalles de devolución:</h3>
      </div>
      <hr />

      <ClientHeader data={headerData} config={REFUND_HEADER_CONFIG} />
      <hr />

      <DetailsSummarySection
        summaryFields={summaryFields}
        extraFields={fieldsToRender}
        summaryTitle="DETALLES DEVOLUCION"
        summaryOpenLabel="Abrir detalles de la devolucion"
        summaryCloseLabel="Cerrar detalles de la devolucion"
        summaryColumns={3}
      />

      <PaymentAttachmentsCard
        images={paymentAttachments.images}
        files={paymentAttachments.files}
        title="ADJUNTO(S)"
        emptyDescription="Cuando esta devolución tenga imágenes o archivos asociados, aparecerán aquí para su revisión."
      />
      <hr />

      <div className="mr-85 mb-10">
        <b>Productos en devolución:</b>
      </div>

      <Table hover responsive>
        <thead className="table-header-gray-mui">
          <tr>
            <th>CÓDIGO</th>
            <th>NOMBRE DEL PRODUCTO</th>
            <th>N° LOTE</th>
            <th>MOTIVO</th>
            <th>PESO NETO</th>
            <th>UNIDAD DE VENTA</th>
            <th>CANTIDAD</th>
            <th>PRECIO</th>
            <th>SUB-TOTAL</th>
            {extraColumns.map((col, index) => (
              <th key={`col-${index}`} className="column-custom">
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {processedDetails.length > 0 ? (
            processedDetails.map((product, index) => (
              <tr key={index}>
                <td className="order-td-text">{product.product_db_ref}</td>
                <td className="order-td-text">{product.product_name}</td>
                <td className="order-td-text">{product.batch_number || 'N/A'}</td>
                <td className="order-td-text">{product.motive || 'N/A'}</td>
                <td className="order-td-text">{getRefundWeight(product.weight)}</td>
                <td className="order-td-text">{product.price_unit}</td>
                <td className="order-td-money">{Number(product.quantity || 0).toFixed(2)}</td>
                <td className="order-td-money">{formatMoney(Number(product.unit_price || 0))}</td>
                <td className="order-td-money">
                  {formatMoney(
                    getRefundRowSubtotal(product.extended_price, product.discount_price)
                  )}
                </td>
                {extraColumns.map((col, idx) => (
                  <td key={`val-${index}-${idx}`} className="order-td-text column-custom">
                    {product.customFieldValues[col] || 'N/A'}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={9 + extraColumns.length} className="order-td-text">
                No hay resultados
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <TotalsSummaryCard rows={formattedTotalRows} />
    </div>
  )
}
